// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerCorePEPMRow() {
   const state = useQuoteContext()

   if (state.resellerCustomerQuoteValues.corePEPM > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {state.product_list[state.coreProductSelected]['ProductName']}
            </div>
            <div className='col'>
               {state.productCoreEECount >
               state.product_list[state.coreProductSelected]['MinimumEmployees']
                  ? formatFloatAsCurrencySymbol(
                       state.resellerCustomerQuoteValues.corePEPM,
                       state.currencyObject,
                    )
                  : 'Flat Rate'}
            </div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.coreTotalPrice,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
